/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { AdsActions } from '../../../Redux/AdsRedux';
import { NewsActions } from '../../../Redux/NewsRedux';
import './style.scss';
class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      loading: false,
      path: window.location.pathname,
      categories: [],
    };
    this.hasCate = 0;
    this.hasHot = 0;
  }

  getCategories = () => {
    axios.get('/api/v1/categories/show-home').then(({ data }) => {
      if (data.success) {
        this.setState(
          {
            categories: [...data.payload],
          },
          () => {
            this.hasCate = 1;
          }
        );
        this.props.setCategories([...data.payload]);
      }
    });
  };
  getMetadata = () => {
    axios.get('/api/v1/meta').then(({ data }) => {
      if (data.success) {
        this.setState({
          user: data.payload.user,
        });
        if (data.payload.ads) {
          this.props.setAds(data.payload.ads);
        }
      }
      this.setState({
        loading: true,
      });
    });
  };

  componentDidUpdate() {
    if (this.hasCate === 1) {
      this.hasCate = 2;
      const event = new Event('navmenu');
      // Dispatch the event.
      window.dispatchEvent(event);
    }

    if (this.hasHot === 0) {
      const { articles } = this.props;
      if (articles.featuredArticles.length > 0) {
        this.hasHot = 1;
        const event = new Event('tophot');
        // Dispatch the event.
        window.dispatchEvent(event);
      }
    }
  }

  componentDidMount() {
    this.getMetadata();
    this.getCategories();
  }

  handleLogout = (e) => {
    e.preventDefault();
    axios.get('/api/v1/logout').then(({ data }) => {
      if (data.success) {
        window.location.href = '/';
      }
    });
  };

  render() {
    const { user, categories } = this.state;
    const { articles } = this.props;
    // if (articles.featuredArticles.length > 0) {
    //   window.vTicker = {};
    //   window.vTicker.datetime = true;
    // }
    return (
      <header className='main-header header-style-1'>
        <div class='col-12' style={{ backgroundColor: '#f1f1f1' }}>
          <a
            target='_blank'
            href='https://mic.gov.vn/mic_2020/Pages/trangchu_2020.aspx'
            class='py-1 container'
            style={{ display: 'flex', fontSize: '0.8rem' }}
          >
            {' '}
            Bộ Thông tin và Truyền thông - Chương trình Chuyển đổi số Quốc gia{' '}
          </a>
        </div>
        <div className='top-bar pt-10 pb-10 background-white d-none d-md-block'>
          <div className='container'>
            <div className='row'>
              <div className='col-9 d-flex'>
                {/* <div className='language d-flex justify-content-center align-items-center font-small col-1'>
                  <div
                    id='langMenuDropdow'
                    className='dropdown-menu dropdown-menu-left'
                    aria-labelledby='langMenu'
                  >
                    <a className='dropdown-item' href='?lng=vi'>
                      VI
                    </a>
                  </div>
                  <a
                    className='dropdown-toggle'
                    href='#'
                    role='button'
                    id='langMenu'
                    data-toggle='dropdown'
                    aria-haspopup='true'
                    aria-expanded='false'
                  >
                    <i className='ti-world mr-5'></i>
                    <span>VI</span>
                  </a>
                </div> */}
                <div id='datetime' className='d-flex col-11 m-0 p-0'>
                  <ul>
                    {articles.featuredArticles.map(({ slug, title, id }) => (
                      <li className='w-100' key={id}>
                        <a
                          className='active d-block w-100'
                          href={'/tin-tuc/' + slug}
                        >
                          <span className='font-small w-100'>
                            <i className='ti-book mr-5'></i>
                            {title.substr(0, 140)}
                          </span>
                        </a>
                      </li>
                    ))}
                    {/* <li>
                      <span className='font-small'>
                        <i className='ti-calendar mr-5'></i>Monday, April 6,
                        2020
                      </span>
                    </li>
                    <li>
                      <a className='active' href='#'>
                        <span className='font-small'>
                          <i className='ti-book mr-5'></i>Read Today’s Paper
                        </span>
                      </a>
                    </li> */}
                  </ul>
                </div>
              </div>
              <div className='col-3 text-right'>
                <ul className='header-social-network d-inline-block list-inline'>
                  {/* <li className='list-inline-item'>
                    <a
                      className='social-icon facebook-icon text-xs-center'
                      target='_blank'
                      href='#'
                    >
                      <i className='ti-facebook'></i>
                    </a>
                  </li> */}
                  {/* <li className='list-inline-item'>
                    <a
                      className='social-icon twitter-icon text-xs-center'
                      target='_blank'
                      href='#'
                    >
                      <i className='ti-twitter-alt'></i>
                    </a>
                  </li>
                  <li className='list-inline-item'>
                    <a
                      className='social-icon pinterest-icon text-xs-center'
                      target='_blank'
                      href='#'
                    >
                      <i className='ti-pinterest'></i>
                    </a>
                  </li>
                  <li className='list-inline-item'>
                    <a
                      className='social-icon instagram-icon text-xs-center'
                      target='_blank'
                      href='#'
                    >
                      <i className='ti-instagram'></i>
                    </a>
                  </li> */}
                </ul>
                <div className='vline-space d-inline-block'></div>
                {user ? (
                  <div className='user-account d-inline-block font-small'>
                    <a
                      className='dropdown-toggle'
                      href='#'
                      role='button'
                      id='userMenu'
                      data-toggle='dropdown'
                      aria-haspopup='true'
                      aria-expanded='false'
                    >
                      <i className='ti-user'></i>
                      <span>
                        Xin chào,
                        {user.company
                          ? user.company.name.substr(0, 5)
                          : user.name.substr(0, 5)}
                      </span>
                    </a>
                    <div
                      id='userMenuDropdow'
                      className='dropdown-menu dropdown-menu-right'
                      aria-labelledby='userMenu'
                    >
                      <a className='dropdown-item' href='/bang-dieu-khien'>
                        <i className='ti-settings'></i>Bảng điều khiển
                      </a>
                      <div className='dropdown-divider'></div>
                      <a
                        className='dropdown-item'
                        onClick={(e) => this.handleLogout(e)}
                      >
                        <i className='ti-share'></i>Đăng xuất
                      </a>
                    </div>
                  </div>
                ) : (
                  <a href='/dang-nhap' role='button'>
                    <span>Đăng nhập</span>
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className='header-logo background-white text-center pt-20 pb-20 d-none d-lg-block'>
          <div className='container'>
            <div className='row'>
              <div className='col-12'>
                <a href='/'>
                  <img
                    className='logo-img d-inline'
                    src='/assets/img/logo.png'
                    alt=''
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className='header-bottom header-sticky background-white text-center'>
          <div className='mobile_menu d-lg-none d-block'></div>
          <div className='container'>
            <div className='row'>
              <div className='col-12'>
                <a href='/' className='header-logo-mobile'>
                  <img
                    className='logo-img d-inline'
                    src='/assets/img/logo.png'
                    alt=''
                  />
                </a>
                <div className='main-nav text-center d-none d-lg-block'>
                  <nav>
                    <ul id='navigation' className='main-menu'>
                      <li>
                        <a href='/'>Trang chủ</a>
                      </li>
                      <li className='menu-item-has-children'>
                        <a>Chuyên mục</a>
                        <ul className='sub-menu'>
                          {categories.map(
                            ({ category_name, id, slug, is_campaign }) => (
                              <li key={id}>
                                <a
                                  href={`/${
                                    is_campaign == 1 ? 'chuyen-muc' : 'tin-tuc'
                                  }/${slug}`}
                                >
                                  {category_name}
                                </a>
                              </li>
                            )
                          )}
                        </ul>
                      </li>
                      <li>
                        <a href='/nen-tang-so'>Nền tảng đồng hành</a>
                      </li>
                      <li>
                        <a href='/huong-dan-su-dung'>Hướng dẫn sử dụng</a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

const MapStateToProps = (state) => {
  return { articles: state.articles };
};

const MapActionToProps = (dispatch) => {
  return {
    setAds: (ads) => dispatch(AdsActions.setAds(ads)),
    setCategories: (categories) =>
      dispatch(NewsActions.setCategories(categories)),
  };
};
export default connect(MapStateToProps, MapActionToProps)(Header);
